import React from "react";
import { last } from "lodash";
import { Radio } from "../../Inputs/Radio";

interface Props {
  values: Array<number>;
  spec: Array<number>;
  onChange: (values: Array<number>) => void
}

const EnsembleMembersSelector = (props: Props) => {
  const { spec, values, onChange } = props;
  const options = spec.filter(v => v === 50 || v === 100);
  const selectedOption = last(values.filter(v => v === 50 || v === 100))

  const onValueChange = (value: string | Array<string>) => {
    if (value) {
      onChange(spec.filter(i => i <= Number(value)));
    } else {
      onChange([]);
    }
  }

  return (
    <div className="ensemble-members-control">
      {
        options.map(option => {
          return <Radio
            value={option.toString()}
            key={option}
            label={option.toString()}
            name="ensemble-members"
            onChange={onValueChange}
            checked={option === selectedOption}
          />
        })
      }
    </div>

  )
}

export default EnsembleMembersSelector;
